module.exports = __webpack_public_path__ + "static/media/csaward.c6efb312.jpg";